import React from 'react';

import type { StatusPillProps } from '@components/StatusPill';
import { StatusPill } from '@components/StatusPill';

interface TagProps {
  label: string;
  color: string | null;
  variant?: StatusPillProps['variant'];
}

function Tag({ label, color, variant = 'secondary' }: TagProps) {
  return <StatusPill name={label} color={color} variant={variant} />;
}

export default Tag;
